"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_APP_CONFIG_URL = exports.FETCH_RECENT_NOTIFICATIONS = exports.FETCH_UNREAD_NOTIFICATIONS_COUNT = exports.FETCH_NOTIFICATIONS = exports.PATCH_BOOKING_SERVICE_URL = exports.FETCH_SALE_URL = exports.FETCH_CHECK_AVAILABILITY_URL = exports.FETCH_BOOKING_CREATE_URL = exports.FETCH_BOOKING_URL = exports.ELASTIC_SAAS_CATALOG_SEARCH_URL = exports.FETCH_TREATMENTS = exports.ROOT_CATEGORIES = exports.FETCH_ACTIVITY_CREATE_URL = exports.ACTIVITY_URL = exports.PATCH_OPENED_DAYS_RESOURCE_URL = exports.FETCH_PHYSICAL_RESOURCES_URL = exports.FETCH_HUMAN_RESOURCES_URL = exports.FETCH_LOGICAL_DAY_PR_URL = exports.FETCH_LOGICAL_DAY_HR_URL = exports.FETCH_COMPANY_URL = exports.FETCH_USER_URL = exports.CUSTOMER_URL = exports.SAAS_TOKEN_KEY = exports.MKP_TOKEN_KEY = exports.LOGOUT_URL = exports.FORGOT_PASSWORD_URL = exports.LOGIN_URL = exports.FIRST_LEVEL_DISCOUNT = void 0;
exports.FIRST_LEVEL_DISCOUNT = "\n    id\n    resourceId\n    range{\n        start\n        end\n    },\n    discount,\n    recurrence{\n        id\n        rules\n        description\n    }\n";
// AUTH
exports.LOGIN_URL = '/users/login-sso';
exports.FORGOT_PASSWORD_URL = '/users/forgotPwd';
exports.LOGOUT_URL = '/users/logout';
exports.MKP_TOKEN_KEY = 'marketplaceToken';
exports.SAAS_TOKEN_KEY = 'saasToken';
// CUSTOMER
exports.CUSTOMER_URL = '/v2/customers';
exports.FETCH_USER_URL = '/users/logged';
exports.FETCH_COMPANY_URL = '/companies/logged';
// LOGICAL_DAY
exports.FETCH_LOGICAL_DAY_HR_URL = '/logical-day-hr';
exports.FETCH_LOGICAL_DAY_PR_URL = '/logical-day-pr';
// RESOURCE
exports.FETCH_HUMAN_RESOURCES_URL = '/humanResources';
exports.FETCH_PHYSICAL_RESOURCES_URL = '/physicalResources';
exports.PATCH_OPENED_DAYS_RESOURCE_URL = '/days';
// ACTIVITY
exports.ACTIVITY_URL = '/activities';
exports.FETCH_ACTIVITY_CREATE_URL = '/activities/unavailabilities';
// TREATMENT
exports.ROOT_CATEGORIES = '/categories/root';
exports.FETCH_TREATMENTS = 'categories/flat-category';
exports.ELASTIC_SAAS_CATALOG_SEARCH_URL = '/saas-catalog/_search';
// BOOKING
exports.FETCH_BOOKING_URL = '/bookings';
exports.FETCH_BOOKING_CREATE_URL = '/bookings/create-without-availability-check';
exports.FETCH_CHECK_AVAILABILITY_URL = '/bookings/check-availability';
// SALES
exports.FETCH_SALE_URL = '/sales';
exports.PATCH_BOOKING_SERVICE_URL = '/bookingServices';
// NOTIFICATIONS
exports.FETCH_NOTIFICATIONS = '/notifications';
exports.FETCH_UNREAD_NOTIFICATIONS_COUNT = '/notifications/count-unread';
exports.FETCH_RECENT_NOTIFICATIONS = '/notifications/most-recent';
// APP CONFIG
exports.FETCH_APP_CONFIG_URL = '/app/code';
